import React, { createContext, useContext, useState, useCallback } from 'react';

const SubscriptionModalContext = createContext({
  isUpgradeModalOpen: false,
  isStartSubscriptionModalOpen: false,
  setUpgradeModalOpen: () => {},
  setStartSubscriptionModalOpen: () => {},
});

export function SubscriptionModalProvider({ children }) {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [isStartSubscriptionModalOpen, setIsStartSubscriptionModalOpen] = useState(false);

  const handleSetUpgradeModalOpen = useCallback((value) => {
    setIsUpgradeModalOpen(value);
  }, []);

  const handleSetStartSubscriptionModalOpen = useCallback((value) => {
    setIsStartSubscriptionModalOpen(value);
  }, []);

  const value = {
    isUpgradeModalOpen,
    isStartSubscriptionModalOpen,
    setUpgradeModalOpen: handleSetUpgradeModalOpen,
    setStartSubscriptionModalOpen: handleSetStartSubscriptionModalOpen,
  };

  return (
    <SubscriptionModalContext.Provider value={value}>
      {children}
    </SubscriptionModalContext.Provider>
  );
}

export function useSubscriptionModalState() {
  const context = useContext(SubscriptionModalContext);
  if (!context) {
    throw new Error(
      'useSubscriptionModalState must be used within SubscriptionModalProvider'
    );
  }
  return context;
}
